import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CreateCvService } from 'src/app/shared/services/create-cv.service';

@Component({
  selector: 'app-cv-create',
  templateUrl: './cv-create.component.html',
  styleUrls: ['./cv-create.component.scss']
})
export class CvCreateComponent {
  form: FormGroup;
  languages = [
    {
      label: 'DE',
      value: 'GERMAN'
    },
    {
      label: 'EN',
      value: 'ENGLISH'
    }
  ]
  showMaxLengthWarning = false;

  constructor(private fb: FormBuilder, private createCvService: CreateCvService) {
    this.form = this.fb.group({
      language: ['GERMAN', Validators.required],
      name: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(100)]]
    })
    this.form.controls.name.valueChanges.subscribe(changes => {
      this.showMaxLengthWarning = changes.length == 100;
    })
  }

  createCv() {
    this.createCvService.emitCvData(this.form.getRawValue());
  }

  close() {
    this.createCvService.closeCreateSideBar();
  }
}
